import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import {
  CircularProgress
} from "@mui/material"

import socket from '../../../services/socket';


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nome' },
  { id: 'sales', numeric: true, disablePadding: false, label: 'Vendas(R$)' },
  { id: 'ARPPU', numeric: true, disablePadding: false, label: 'Ticket médio(R$)' },
  { id: 'conversion', numeric: true, disablePadding: false, label: 'Taxa de conversão(%)' },
  { id: 'PA', numeric: true, disablePadding: false, label: 'PA' },
  { id: 'attendance', numeric: true, disablePadding: false, label: 'Atendimentos' },
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.primary.main,
          backgroundColor: lighten(theme.palette.primary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.primary.light,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected,selected,store } = props;
  // console.log("Aqui: "+selected)

  
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Tooltip title="Avalie seus vendedores entre eles, seus pontos fortes e fracos, selecionando e clicando no botão comparar à direita!">
        <IconButton aria-label="Selecionar" size="large">
          <InfoIcon />
        </IconButton>
      </Tooltip>

      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} Selecionados
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          Vendedor
        </Typography>
      )}

      {numSelected > 0 ? ( 
        <Tooltip title="Comparar">
          <Button variant="outlined" color="primary"
          onClick={()=>{
            sessionStorage.setItem('selectedSellers',JSON.stringify(selected));
            sessionStorage.setItem('selectedStoreInf',JSON.stringify(store));
            window.location.href = "/vezo/compare"
          }}>
            Comparar
          </Button>
        </Tooltip>
      ) : ( 
        <Tooltip title="Nenhum item selecionado!">
          <Button variant="outlined" color="primary"    
            onClick={() => { 
              alert('Selecionar vendedores!')
            }}>
            Comparar
          </Button>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: lighten(theme.palette.primary.light, 0.5)
    }
  },
  tableCell: {
    "$selected &": {
      color: lighten(theme.palette.primary.light, 0.5)
    }
  },
  selected: {}
}));

export default function SellerListNew(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('Vendas');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [sellers,setSellers] = React.useState([])
  const [store,setStore] = React.useState([])
  const [isLoading,setIsLoading] = useState(true);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect( () => {   
    function askRankingMainInf(){
      socket.emit('/vezo/rankingSeller/askMainInformation',{ 
                      'store_id': props.store_id,
                      'date': props.date
                    }
                    ,(data)=>{console.log(data);})
    }

    async function loadRankingMainInf(){
      askRankingMainInf()
      socket.on('/vezo/rankingSeller/updateMainInformation/'+props.store_id,()=>{
        // When the server sends a updatePaperInfo, it asks for newer intel
        askRankingMainInf();
      })
      
      socket.on('/vezo/rankingSeller/MainInformation/'+props.store_id,(data)=>{
        const sellersInit = data.map((row,index)=>{
          return ({    
              "id": row.id,
              "name":   row.name,
              'img_url': row.image?Buffer.from(row.image).toString():"I",
              'sales': row.sales,
              'ARPPU': row.ARPPU,
              'conversion': row.conversion,
              'PA': row.PA,
              'attendance': row.attendance
          })   
        });

        setSellers(sellersInit)
        setIsLoading(false);
      });
      return () => socket.disconnect();
    }

    function askStoreInf(){
      socket.emit('/vezo/rankingSeller/askStoreInformation',{ 
                      'store_id': props.store_id,
                      'date': props.date
                    }
                    ,(data)=>{console.log(data);})
    }

    async function loadStoreInf(){
      askStoreInf()
      socket.on('/vezo/rankingSeller/updateStoreInformation/'+props.store_id,()=>{
        // When the server sends a updatePaperInfo, it asks for newer intel
        askStoreInf();
      })
      socket.on('/vezo/rankingSeller/StoreInformation/'+props.store_id,(data)=>{
        setStore(data)
      });
      return () => socket.disconnect();
    }

    loadStoreInf()
    loadRankingMainInf();    
    
  },[props.store_id,props.date]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(sellers);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, sellers.length - page * rowsPerPage);
  
    return (isLoading) ?
    <div style={{paddingTop:'10px'}}>
      <CircularProgress />
    </div>
    :
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar numSelected={selected.length} selected={selected} store={store} />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={sellers.length}
            />
            <TableBody>
              {stableSort(sellers, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      selected={isItemSelected}
                      classes={{ selected: classes.selected }}
                      className={classes.tableRow}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row" padding="none">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.sales}</TableCell>
                      <TableCell align="right">{row.ARPPU}</TableCell>
                      <TableCell align="right">{row.conversion}</TableCell>
                      <TableCell align="right">{row.PA}</TableCell>
                      <TableCell align="right">{row.attendance}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage = "Linhas"
          component="div"
          count={sellers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>;



}